import React from 'react'
import ReactDOM from 'react-dom/client'

import './index.css'
import Router from './router/Router'
import { init } from './ClevertapWrapper'
import { initWorkers } from './notifications-workers'
import { AuthProvider } from './context/loginContext/loginContext'
import { FeatureProvider } from './context/useFeatureFlagContext'
import SpinnerProvider from './context/spinnerContext'
import { BrowserRouter } from 'react-router-dom'
import { UpsellingProvider } from './context/upsellingContext'
import { getJWT } from './Utils/Profile'
import { BASEAPI } from './services/constants'
import TagManager from 'react-gtm-module'

init()
initWorkers()

const tagManagerArgs = {
    gtmId: 'GTM-TRKH3KGQ',
}

TagManager.initialize(tagManagerArgs)

//Refresh Token -- It will be deleted in April
const { fetch: originalFetch } = window
window.fetch = async (...args) => {
    const [resource, config] = args
    const headers = config?.headers as any
    const refreshTokenURL = `${BASEAPI}amipos-back/auth/refresh-token`
    const jwt = getJWT()
    try {
        if (
            refreshTokenURL !== resource &&
            config &&
            config.headers &&
            jwt.length > 0 &&
            jwt.length < 60
        ) {
            const resp = await fetch(refreshTokenURL, {
                headers: { Authorization: jwt },
                method: 'POST',
            })
            const respParsed = await resp.json()
            const currentUser = localStorage.getItem('currentUser')
            const user = currentUser && JSON.parse(currentUser)
            user.token = respParsed.token
            headers['Authorization'] = respParsed.token
            localStorage.setItem('currentUser', JSON.stringify(user))
        }
    } catch (e) {
        // If it fails, the request will continue without any change
        console.log('ERROR  INTERCEPTOR', e)
    }

    const response = await originalFetch(resource, config)
    return response
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <UpsellingProvider>
        <AuthProvider>
            <FeatureProvider>
                <SpinnerProvider>
                    <BrowserRouter>
                        <Router />
                    </BrowserRouter>
                </SpinnerProvider>
            </FeatureProvider>
        </AuthProvider>
    </UpsellingProvider>
)
